import { render, staticRenderFns } from "./stationDetail.vue?vue&type=template&id=33bbb684&scoped=true&"
import script from "./stationDetail.vue?vue&type=script&lang=js&"
export * from "./stationDetail.vue?vue&type=script&lang=js&"
import style0 from "./stationDetail.vue?vue&type=style&index=0&id=33bbb684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbb684",
  null
  
)

export default component.exports